import { Card, Loading, NotFound, useHasPermission, useIsAddonEnabled } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { Route, Routes, useParams } from "react-router";
import { eventService } from "../../shared/api/event/eventService";
import { ArchivedEventContacts } from "./ArchivedEventContacts";
import { ArchivedEventOverview } from "./ArchivedEventOverview";
import { ClippingProviderContactList } from "./ClippingProviderContactList";
import { EventDetailsCard } from "./EventDetailsCard";

export const ArchivedEventDetailsPage: FC = () => {
	const { eventId = "" } = useParams<"eventId">();
	const { data: event, isLoading } = useQuery({
		queryKey: eventService.detailKey(eventId),
		queryFn: () => eventService.detail(eventId).then((response) => response.data.data),
	});
	const isPressModuleEnabled = useIsAddonEnabled("pressModule");
	const isContactDatabaseEnabled = useIsAddonEnabled("contactDatabase");
	const canReadContacts = useHasPermission(["contact.read"]);
	const canReadClippingProviderContacts = useHasPermission(["clippingProviderContact.read"]);

	if (!event || isLoading) {
		return (
			<Card>
				<Loading />
			</Card>
		);
	}

	return (
		<Routes>
			<Route element={<ArchivedEventOverview event={event} />}>
				<Route index path="details" element={<EventDetailsCard event={event} isArchived={true} />} />
				{isContactDatabaseEnabled && canReadContacts && (
					<Route path="contacts" element={<ArchivedEventContacts event={event} />} />
				)}
				{isContactDatabaseEnabled && isPressModuleEnabled && canReadClippingProviderContacts && (
					<Route path="clipping-provider-contacts" element={<ClippingProviderContactList />} />
				)}
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
